"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.covertUrl = exports.openMapAddress = exports.urlPrams = exports.isImage = exports.isIphoneX = exports.FullAccess = exports.closeModal = exports.scrollToElemError = exports.goExternalUrl = exports.reReplaceChars = exports.replaceChars = exports.ifMobileWidth = exports.isMobileBrowser = exports.ifIos = exports.ifMobile = exports.Initials = exports.getCaseStatus = exports.LIST_GENERIC_TYPES = exports.ITEM_GENERIC_TYPES = exports.CASE_STATUSES = void 0;
exports.CASE_STATUSES = {
    0: {
        name: "pending",
        className: 'pending'
    },
    1: {
        name: "matched",
        className: 'matched'
    },
    2: {
        name: "matched",
        className: 'matched'
    },
    3: {
        name: "waiting approval",
        className: 'waitingApproval'
    },
    4: {
        name: "closed",
        className: 'closed'
    },
    5: {
        name: "deleted",
        className: 'deleted'
    },
    6: {
        name: "canceled",
        className: 'canceled'
    },
    7: {
        name: "rejected",
        className: 'v2-rejected'
    },
    8: {
        name: "closed",
        className: 'admin-approved'
    },
    9: {
        name: "rejected",
        className: 'admin-rejected'
    },
    99: {
        name: "deleted",
        className: 'deleted'
    },
    "accepted": {
        name: "matched",
        className: 'matched'
    },
    "closed": {
        name: "closed",
        className: 'closed'
    },
    "canceled": {
        name: "canceled",
        className: 'canceled'
    },
    fatt: {
        0: {
            name: "pending",
            className: 'pending'
        },
        1: {
            name: "matched",
            className: 'matched'
        },
        2: {
            name: "in revision",
            className: 'in-revision'
        },
        3: {
            name: "in revision",
            className: 'in-revision'
        },
        4: {
            name: "closed",
            className: 'closed'
        },
        5: {
            name: "canceled",
            className: 'canceled'
        },
        6: {
            name: "system canceled",
            className: 'canceled'
        },
        7: {
            name: "in revision",
            className: 'in-revision'
        },
        8: {
            name: "closed",
            className: 'closed'
        },
        9: {
            name: "rejected",
            className: 'v2-rejected'
        },
        99: {
            name: "deleted",
            className: 'deleted'
        },
        "accepted": {
            name: "matched",
            className: 'matched'
        },
        "closed": {
            name: "closed",
            className: 'closed'
        },
        "canceled": {
            name: "canceled",
            className: 'canceled'
        },
    },
    tr: {
        0: {
            name: "pending",
            className: 'pending'
        },
        1: {
            name: "matched",
            className: 'matched'
        },
        2: {
            name: "rejected",
            className: 'v2-rejected'
        },
        3: {
            name: "closed",
            className: 'closed'
        },
        5: {
            name: "canceled",
            className: 'canceled'
        },
        6: {
            name: "system canceled",
            className: 'canceled'
        },
        99: {
            name: "deleted",
            className: 'deleted'
        },
        "accepted": {
            name: "matched",
            className: 'matched'
        },
        "closed": {
            name: "closed",
            className: 'closed'
        },
        "canceled": {
            name: "canceled",
            className: 'canceled'
        },
    },
    cr: {
        0: {
            name: "pending",
            className: 'pending'
        },
        1: {
            name: "matched",
            className: 'matched'
        },
        2: {
            name: "rejected",
            className: 'v2-rejected'
        },
        3: {
            name: "closed",
            className: 'closed'
        },
        5: {
            name: "canceled",
            className: 'canceled'
        },
        6: {
            name: "system canceled",
            className: 'canceled'
        },
        99: {
            name: "deleted",
            className: 'deleted'
        },
        "accepted": {
            name: "matched",
            className: 'matched'
        },
        "closed": {
            name: "closed",
            className: 'closed'
        },
        "canceled": {
            name: "canceled",
            className: 'canceled'
        },
    }
};
exports.ITEM_GENERIC_TYPES = {
    case: [{
            title: 'Case Name',
            key: 'casename',
        }, {
            title: 'Case Type',
            key: 'casetype'
        }, {
            title: 'Appearance Type',
            key: 'appearanceType'
        }],
    depo: [{
            title: 'Case Name',
            key: 'casename',
        }, {
            title: 'Case Type',
            key: 'casetype'
        }, {
            title: 'Sch Hrs / Auth Hrs',
            multiple: true,
            key: ['scheduledprice', 'authorizedprice']
        }],
    tr: [{
            title: 'Case Name',
            key: 'casename',
        }, {
            title: 'Proceeding Type',
            key: 'casetype',
        }, {
            title: 'Target Language',
            key: 'language.name',
        }, {
            title: 'Proficiency Level',
            key: 'level.type',
        }],
    cr: [{
            title: 'Case Name',
            key: 'casename'
        }, {
            title: 'Proceeding Type',
            key: 'casetype'
        }, {
            title: 'Subtype',
            key: 'casesubtype.name'
        }],
    fatt: [{
            title: 'State',
            key: 'state',
        }, {
            title: 'Case Type',
            key: 'casetype',
        }, {
            title: 'Assignment Type',
            key: 'assignment_type_title',
        }],
    rc: [{
            title: "State",
            key: 'state'
        }, {
            title: 'Case Type',
            key: 'casetype'
        }, {
            title: 'Case Subtype',
            key: 'casesubtype.name'
        }]
};
exports.LIST_GENERIC_TYPES = {
    case: [
        {
            key: 'date',
            className: 'date'
        },
        {
            key: 'genericType',
            className: 'case-type'
        },
        {
            key: ['casetype', 'appearanceType'],
            className: 'case-sub-type',
            multiple: true
        },
        {
            key: ['court', 'department'],
            className: 'address',
            multiple: true
        }
    ],
    depo: [
        {
            key: 'date',
            className: 'date'
        },
        {
            key: 'genericType',
            className: 'case-type'
        },
        {
            key: ['casetype', 'appearanceType'],
            className: 'case-sub-type',
            multiple: true
        },
        {
            key: 'fullAddress',
            className: 'address',
        }
    ],
    tr: [
        {
            key: 'date',
            className: 'date'
        },
        {
            key: 'genericType',
            className: 'case-type'
        },
        {
            key: 'casetype',
            className: 'case-sub-type',
        },
        {
            key: 'location',
            className: 'address',
        }
    ],
    cr: [
        {
            key: 'date',
            className: 'date'
        },
        {
            key: 'genericType',
            className: 'case-type'
        },
        {
            key: ['casetype', 'casesubtype.name'],
            className: 'case-sub-type',
            multiple: true
        },
        {
            key: 'location',
            className: 'address',
        }
    ],
    fatt: [
        {
            key: 'deadline',
            className: 'date'
        },
        {
            key: 'genericType',
            className: 'case-type'
        },
        {
            key: ['casetype', 'assignment_type_title'],
            className: 'case-sub-type',
            multiple: true
        },
    ],
    rc: [
        {
            key: 'genericType',
            className: 'case-type'
        },
        {
            key: ['casetype', 'casesubtype.name'],
            className: 'case-sub-type',
            multiple: true
        },
    ]
};
const getCaseStatus = (status) => exports.CASE_STATUSES[status];
exports.getCaseStatus = getCaseStatus;
const Initials = (name) => {
    if (!name)
        return '';
    const initials = name.match(/\b\w/g) || [];
    return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
};
exports.Initials = Initials;
const ifMobile = () => {
    return window['cordova'] || window['isMobile'];
};
exports.ifMobile = ifMobile;
const ifIos = () => {
    return localStorage.getItem('deviceName') == 'iOS';
};
exports.ifIos = ifIos;
const isMobileBrowser = () => {
    let check = false;
    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
            check = true;
    })(navigator.userAgent || navigator.vendor || window['opera']);
    return {
        check,
        ios: navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)
    };
};
exports.isMobileBrowser = isMobileBrowser;
const ifMobileWidth = () => window.innerWidth <= 768;
exports.ifMobileWidth = ifMobileWidth;
const replaceChars = (text) => {
    return text && text.replace(/\n/g, '<br/>');
};
exports.replaceChars = replaceChars;
const reReplaceChars = (text) => {
    return text && text.replace(/<br\s*\/?>/gi, "\n");
};
exports.reReplaceChars = reReplaceChars;
const goExternalUrl = (url, target = '_blank', event = null) => {
    if (event) {
        event.stopPropagation();
        event.preventDefault();
    }
    // @ts-ignore
    if (exports.ifMobile() && cordova.InAppBrowser && cordova.InAppBrowser.open) {
        // @ts-ignore
        cordova.InAppBrowser.open(url, '_system', 'location=no,enableViewportScale=yes');
    }
    else {
        window.open(url, target);
    }
};
exports.goExternalUrl = goExternalUrl;
const scrollToElemError = (props) => {
    const errorsList = document.getElementsByClassName('Mui-error');
    if (errorsList && errorsList.length) {
        const parent = errorsList[0].parentElement;
        if (props === null || props === void 0 ? void 0 : props.firstFlow) {
            const modal = document.getElementsByClassName('first-flow-modal')[0];
            parent && modal.scroll({ top: parent.offsetTop - 20, behavior: 'smooth' });
        }
        else {
            const header = document.querySelector('.header-navbar');
            parent && window.scroll({ top: parent.offsetTop - header.offsetHeight, behavior: 'smooth' });
        }
    }
    return;
};
exports.scrollToElemError = scrollToElemError;
const closeModal = (modalId) => {
    // get modal
    const modal = document.getElementsByClassName(modalId)[0];
    if (modal) {
        // change state like in hidden modal
        modal.classList.remove('show');
        modal.setAttribute('aria-hidden', 'true');
        modal.setAttribute('style', 'display: none');
        // get modal backdrop
        const modalBackdrops = document.getElementsByClassName('modal-backdrop');
        // remove opened modal backdrop
        if (modalBackdrops.length) {
            document.body.removeChild(modalBackdrops[0]);
        }
    }
};
exports.closeModal = closeModal;
const FullAccess = (user) => {
    const accessFull = !user.access || user.access === 1;
    const both = parseInt(user.roleType) > 0;
    return {
        val: both && accessFull,
        behavior: accessFull && !both ? 'access' : 'role'
    };
};
exports.FullAccess = FullAccess;
const isIphoneX = () => {
    try {
        //@ts-ignore
        const iphoneModel = window.device.model;
        const m = iphoneModel.match(/iPhone(\d+),?(\d+)?/);
        const model = +m[1];
        if (model >= 10) { // is iphone X
            return true;
        }
    }
    catch (e) {
    }
    return false;
};
exports.isIphoneX = isIphoneX;
const isImage = (mimetype) => mimetype.match(/.(jpg|jpeg|png|gif)$/i);
exports.isImage = isImage;
// get url param with given key
const urlPrams = (key) => {
    const urlString = window.location.href.replace('/#', '').replace('#/', '');
    const url = new URL(urlString);
    return url.searchParams.get(key);
};
exports.urlPrams = urlPrams;
// open google map address
const openMapAddress = (address, event) => {
    event.stopPropagation();
    event.preventDefault();
    const googleMapsUrl = `http://maps.google.com/?q=${address}`;
    // @ts-ignore
    if (exports.ifMobile() && cordova.InAppBrowser && cordova.InAppBrowser.open) {
        // @ts-ignore
        cordova.InAppBrowser.open(googleMapsUrl, '_system', 'location=no');
    }
    else {
        window.open(googleMapsUrl, "_blank");
    }
};
exports.openMapAddress = openMapAddress;
const covertUrl = (el) => {
    const uri = window.AppearMe.appConfigs.url.replace('/api', '');
    return el.url ? el.url.replace(uri, window.AppearMe.appConfigs.url) : '';
};
exports.covertUrl = covertUrl;
